import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=baabb732&scoped=true&"
import script from "./page3.vue?vue&type=script&lang=js&"
export * from "./page3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baabb732",
  null
  
)

component.options.__file = "page3.vue"
export default component.exports